<template>
  <div v-if="act != null" class="theme-supa" style="height: 100% !important">
    <div id="base_body_header_wrap">
      <div class="color-header">
        <div class="row">
          <div class="col-lg-offset-2 col-lg-8 col-sm-10" v-if="act != null" style="
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 50px;
              ">
            <h4 class="h1-test-container" style="padding-top: unset !important; font-size: 20px; text-align: center;">
              Ближе одређење: {{ act.documentInfo.blizeOdredjenje }}
            </h4>
          </div>
        </div>
      </div>
      <div class="white-header">
        <div class="title-act-supa">
          <div class="row mr-15 row-xs">
            <div class="col-lg-offset-2 col-xl-8 col-lg-12 col-sm-12" v-if="act != null">
              <div class="row hidden-xs col-wrap">
                <div class="col-lg-3 col-sm-3 act-supa-table-title">
                  <span>Врста суда</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-supa-table-title">
                  <span>Ознака и број предмета</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-supa-table-title">
                  <span>Начин објављивања</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-supa-table-title">
                  <span>Број и страна</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-supa-table-content">
                  <span :title="act.documentInfo.vrstaSuda">{{
                    act.documentInfo.vrstaSuda
                  }}</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-supa-table-content">
                  <span :title="act.documentInfo.oznakaBrojPredmetaHtml">{{
                    act.documentInfo.oznakaBrojPredmetaHtml
                  }}</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-supa-table-content">
                  <span :title="act.documentInfo.defProizvod">{{
                    act.documentInfo.defProizvod
                  }}</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-supa-table-content">
                  <span :title="act.documentInfo.defPodatakObjavljivanja">{{
                    act.documentInfo.defPodatakObjavljivanja
                  }}</span>
                </div>
              </div>
              <div class="row visible-xs blue-xs">
                <div class="col-xs-12 act-supa-table-xs">
                  <span>Врста суда: </span>
                  <span>{{ act.documentInfo.vrstaSuda }}</span>
                </div>
                <div class="col-xs-12 act-supa-table-xs">
                  <span>Ознака и број предмета:
                    <span>{{ act.documentInfo.oznakaBrojPredmeta }}</span></span>
                </div>
                <div class="col-xs-12 act-supa-table-xs">
                  <span>Начин објављивања:
                    <span>{{ act.documentInfo.nacinObjavljivanja }}</span></span>
                </div>
                <div class="col-xs-12 act-supa-table-xs">
                  <span>Број и страна:
                    <span>{{
                      act.documentInfo.defPodatakObjavljivanja
                    }}</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div id="searchBarPrimary" :class="{
              'col-lg-offset-2 col-xl-8 col-md-offset-0 col-lg-12 col-sm-offset-0 col-xs-offset-0 col-sm-12 col-xs-12':
                contentSecondary === null && contentSecondaryLink === '',
              'col-lg-5 col-md-5 hidden-xs hidden-sm':
                contentSecondary !== null || contentSecondaryLink !== '',
            }">
          <div class="input-group">
            <span class="input-group-btn">
              <button type="button" class="btn btn-default" @click="onPrintPrimaryClick()" title="Штампа">
                <span class="fa fa-print"></span>
              </button>
              <button class="btn btn-default" type="button" @click="onOnlyActContentClick()"
                title="Отвори само текст акта">
                <span class="fa fa-external-link"></span>
              </button>
              <button type="button" class="btn btn-default" @click="onPrimaryPreviousClick()" title="Претходни резултат">
                <span class="fa fa-chevron-left"></span>
              </button>
            </span>
            <input @keyup="primaryKeyUp" v-model="textSearchPrimary" type="text"
              class="form-control ng-pristine ng-untouched ng-valid" placeholder="Претрага по приказаном тексту" />
            <span class="input-group-btn">
              <button class="btn btn-default" type="button" @click="onPrimaryNextClick()" title="Следећи резултат">
                <span class="fa fa-chevron-right"></span>
              </button>
            </span>
          </div>
        </div>
        <div v-if="contentSecondaryLink !== '' || contentSecondary !== null" :class="{ 'col-lg-5 col-md-5': true }">
          <div class="input-group secondary-search">
            <span class="input-group-btn left-search">
              <button class="btn btn-default" type="button" @click="closeSecondary" title="Затвори панел">
                <span class="fa fa-times"></span>
              </button>
              <button class="btn btn-default" type="button" @click="onPrintSecondaryClick" title="Штампа">
                <span class="fa fa-print"></span>
              </button>
            </span>
            <span class="input-group-btn previous-solo-btn">
              <button class="btn btn-default" type="button" @click="onSecondaryPreviousClick"
                title="Претходни резултат">
                <span class="fa fa-chevron-left"></span>
              </button>
            </span>
            <input @keyup="secondaryKeyUp" v-model="textSearchSecondary" type="text" class="form-control"
              placeholder="Претрага по приказаном тексту" />
            <span class="input-group-btn right-search">
              <button class="last-btn btn btn-default" type="button" @click="onSecondaryNextClick"
                title="Следећи резултат">
                <span class="fa fa-chevron-right"></span>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div :class="{
        'col-lg-offset-2 col-xl-8 col-lg-12 col-sm-12':
          contentSecondary === null && contentSecondaryLink === '',
        'col-lg-5 col-md-5 hidden-xs hidden-sm':
          contentSecondary !== null || contentSecondaryLink !== '',
      }" style="
            height: -moz-calc(100% - 148px);
            height: -webkit-calc(100% - 148px);
            height: -o-calc(100% - 148px);
            height: calc(100% - 148px);
          ">
        <div id="actContentPrimaryScroll" width="100%" height="100%" v-if="contentPrimary !== null" class="view-act"
          style="overflow-y: auto; height: 688px" type="text/html">
          <HtmlDiv id="primaryContentHtml" v-html="contentPrimary" width="100%" height="800px">
          </HtmlDiv>
        </div>
      </div>
      <div v-if="contentSecondaryLink !== '' || contentSecondary !== null" :class="{ 'col-lg-5 col-md-5': true }"
        class="secondary-frame-parent" style="height: 100%;">
        <div class="table-panel1" style="height: calc(100% - 44px);">
          <div id="actContentSecondaryScroll" style="overflow:'scroll'" class="view-act-secondary card-1"
            v-if="contentSecondaryLink !== '' || contentSecondary !== null">
            <HtmlDiv id="actContentSecondary" v-html="contentSecondary" :showChanges="true" width="100%" height="100%"
              style="font-size: 0.80rem; position: relative;"></HtmlDiv>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-lg-2-custom-class-width-12 col-lg-12 col-sm-12 panel-group right-panel supa-panel"
        v-if="act !== null && act.documentInfo !== null" style="
            padding-bottom: 40px;
            padding-left: 15px;
            height: calc(100vh - 318px) !important;
          ">
        <div class="panel panel-default" id="panelSud" v-if="act.documentInfo.sudskoOdeljenje !== null &&
          act.documentInfo.sudskoOdeljenje !== ''
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseSud">
                Суд / Судско одељење
              </a>
            </h5>
          </div>
          <div id="collapseSud" class="panel-body panel-collapse collapse in show"
            v-html="act.documentInfo.sudskoOdeljenje"></div>
        </div>
        <div class="panel panel-default" id="panelPravnaMaterija" v-if="act.documentInfo.pravnaMaterija !== null &&
          act.documentInfo.pravnaMaterija !== ''
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapsePravnaMaterija">
                Правна материја
              </a>
            </h5>
          </div>
          <div id="collapsePravnaMaterija" class="panel-body panel-collapse collapse in show">
            <p>{{ act.documentInfo.pravnaMaterija }}</p>
          </div>
        </div>
        <div class="panel panel-default" id="panelPravnaPodmaterija" v-if="act.documentInfo.pravnaPodmaterija !== null &&
          act.documentInfo.pravnaPodmaterija !== ''
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapsePravnaPodmaterija">
                Правна подматерија
              </a>
            </h5>
          </div>
          <div id="collapsePravnaPodmaterija" class="panel-body panel-collapse collapse in show">
            <p>{{ act.documentInfo.pravnaPodmaterija }}</p>
          </div>
        </div>
        <div class="panel panel-default" id="panelPravnaOblast" v-if="act.documentInfo.pravnaOblast !== null &&
          act.documentInfo.pravnaOblast !== ''
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapsePravnaOblast">
                Правна област
              </a>
            </h5>
          </div>
          <div id="collapsePravnaOblast" class="panel-body panel-collapse collapse in show">
            <p>{{ act.documentInfo.pravnaOblast }}</p>
          </div>
        </div>
        <div class="panel panel-default" id="panelPropisPresudjenja" v-if="act.documentInfo.propisPresudjenjaHtml !== null &&
          act.documentInfo.propisPresudjenjaHtml !== ''
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapsePropisPresudjenja">
                Основни пропис битан за исход поступка
              </a>
            </h5>
          </div>
          <div id="collapsePropisPresudjenja" class="panel-body panel-collapse collapse in show">
            <div style="border-bottom: 1px solid #eee;" v-for="item in act.documentInfo.propisPresudjenjaHtml.split(';')"
              @click="handleArticleClick" :key="item" v-html="item"></div>
          </div>
        </div>
        <div class="panel panel-default" id="panelRelevantnoPravo" v-if="act.documentInfo.relevantnoPravoHtml !== null &&
          act.documentInfo.relevantnoPravoHtml !== ''
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseRelevantnoPravo">
                Релевантно право
              </a>
            </h5>
          </div>
          <div id="collapseRelevantnoPravo" class="panel-body panel-collapse collapse in show">
            <div style="border-bottom: 1px solid #eee;" v-for="item in act.documentInfo.relevantnoPravoHtml.split(';')"
              @click="handleArticleClick" :key="item" v-html="item"></div>
          </div>
        </div>
        <div class="panel panel-default" id="panelOsporeniAkt" v-if="act.documentInfo.osporenAktHtml !== null &&
          act.documentInfo.osporenAktHtml !== ''
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseOsporeniAkt">
                Оспорен акт
              </a>
            </h5>
          </div>
          <div id="collapseOsporeniAkt" class="panel-body panel-collapse collapse in show"
            v-html="act.documentInfo.osporenAktHtml" @click="handleArticleClick"></div>
        </div>
        <div class="panel panel-default" id="panelAnonymizedAttachments" v-if="act.anonymizedAttachments !== null &&
          act.anonymizedAttachments !== ''
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseAnonymizedAttachments">
                Анонимизиран оригинал судске одлуке
              </a>
            </h5>
          </div>
          <div id="collapseAnonymizedAttachments" class="panel-body list-group panel-collapse collapse in show"
            v-html="act.anonymizedAttachments"></div>
        </div>
        <div class="panel panel-default" id="panelAttachments"
          v-if="act.attachments !== null && act.attachments.length > 0">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a data-toggle="collapse" class="panel-link" data-target="#collapseAttachments">Прилози</a>
            </h5>
          </div>
          <ul id="collapseAttachments" class="panel-body list-group" style="padding: 0px !important"
            v-html="act.attachments"></ul>
        </div>
        <div class="panel panel-default" id="panelReferences" v-if="act.references !== null && act.references.length > 0">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a data-toggle="collapse" class="panel-link" data-target="#collapseReferences">Повезани акти</a>
            </h5>
          </div>
          <div id="collapseReferences" class="panel-body panel-collapse collapse in list-panel  show">
            <ul class="panel-body list-group" style="padding: 0px !important">
              <li class="list-group-item" v-for="ref in act.references" :key="ref.url">
                <a rel="nofollow" :href="ref.url" target="_blank">{{
                  ref.name
                }}</a>
              </li>
              <!-- end ngRepeat: ref in act.references -->
            </ul>
          </div>
        </div>
        <div class="panel panel-default" id="panelDatumDonosenjaAkta" v-if="act.documentInfo.datumDonosenjaAkta !== null &&
          act.documentInfo.datumDonosenjaAkta !== ''
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseDatumDonosenjaAkta">
                Датум доношења акта
              </a>
            </h5>
          </div>
          <div id="collapseNaciniObjave" class="panel-body panel-collapse collapse in show"
            v-html="act.documentInfo.datumDonosenjaAkta"></div>
        </div>
        <div class="panel panel-default" id="panelDatumUsvajanjaPravnogShvatanja" v-if="act.documentInfo.datumUsvajanjaPravnogShvatanja !== null &&
          act.documentInfo.datumUsvajanjaPravnogShvatanja.trim().length > 0
          ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseDatumUsvajanjaPravnogShvatanja">
                Датум усвајања правног схватања
              </a>
            </h5>
          </div>
          <div id="collapseDatumUsvajanjaPravnogShvatanja" class="panel-body panel-collapse collapse in show">
            <p>{{ act.documentInfo.datumUsvajanjaPravnogShvatanja }}</p>
          </div>
        </div>
        <div class="panel panel-default" id="panelVrstaIshodPostupka"
          v-if="act.documentInfo.defVrstaIshodPostupka !== null">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseVrstaIshodPostupka">
                Врста / исход поступка
              </a>
            </h5>
          </div>
          <div id="collapseVrstaIshodPostupka" class="panel-body panel-collapse collapse in show">
            <p>{{ act.documentInfo.defVrstaIshodPostupka }}</p>
          </div>
        </div>
        <div class="panel panel-default" id="panelObjava" v-if="act.documentInfo.objavaHtml !== null">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseObjava">
                Сви начини објављивања
              </a>
            </h5>
          </div>
          <div id="collapseObjava" class="panel-body panel-collapse collapse in show"
            v-html="act.documentInfo.objavaHtml"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import axios from "axios";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "jquery-highlight/jquery.highlight.js";
import HtmlDiv from "@/components/HtmlDiv.vue";

import { mapState } from 'vuex';
export default {
  name: "ViewActPage",
  data() {
    return {
      baseApiUrl: window.env.VUE_APP_API_SP_DEV,
      baseREGApiUrl: window.env.VUE_APP_API_REG_DEV,
      act: null,
      contentPrimary: null,
      contentSecondary: null,
      contentSecondaryLink: "",
      textSearchPrimary: "",
      textSearchSecondary: "",
      scrollIndexPrimary: 0,
      scrollIndexSecondary: 0,
      userInfo: ''
    };
  },
  watch: {
    textSearchPrimary(newValue) {
      window
        .$("#actContentPrimaryScroll")
        .unhighlight({ className: "pronadjen" });
      if (newValue !== null && newValue.length > 0) {
        window
          .$("#actContentPrimaryScroll")
          .highlight(newValue, { className: "pronadjen" });
      }
      this.scrollIndexPrimary = 0;
    },
    textSearchSecondary(newValue) {
      if (newValue !== null && newValue.length > 0) {
        window
          .$("#actContentSecondaryScroll")
          .unhighlight({ className: "pronadjen" });
        if (newValue !== null && newValue.length > 0) {
          window
            .$("#actContentSecondaryScroll")
            .highlight(newValue, { className: "pronadjen" });
        }
        this.scrollIndexSecondary = 0;
      }
    },
    act() {
      axios
        .get(
          this.baseApiUrl + "Prins/viewAct/" + this.act.documentInfo.htmlUuid
        )
        .then((response) => {
          this.contentPrimary = response.data;
          var self = this;
          this.$nextTick(() => {
            const styleTags = document.getElementById('primaryContentHtml').querySelectorAll('style');
            styleTags.forEach(styleTag => {
              styleTag.innerHTML = '#primaryContentHtml' + styleTag.innerHTML;
              styleTag.innerHTML = styleTag.innerHTML.replace(/}/g, '} #primaryContentHtml');
            });
            window.$("#primaryContentHtml").on("click auxclick", function (e) {
              if (
                e.target.nodeName === "A" ||
                e.target.parentElement.nodeName === "A"
              ) {
                if (e.target.nodeName === "A") {
                  if (
                    e.target.href.includes("/prilozi") &&
                    !e.target.href.includes("actId")
                  )
                    e.target.href =
                      e.target.href +
                      `&actId=${self.act.documentInfo.htmlUuid}`;
                  else if (e.target.href.includes("/viewdoc"))
                    e.target.href = e.target.href.substr(
                      e.target.href.indexOf("/viewdoc")
                    );
                } else {
                  if (e.target.parentElement.href.includes("/prilozi"))
                    e.target.parentElement.href =
                      e.target.parentElement.href +
                      `&actId=${self.act.documentInfo.htmlUuid}`;
                }
              }
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    contentSecondaryLink() {
      if (this.contentSecondaryLink !== "") {
        axios.get(this.contentSecondaryLink).then((response) => {
          this.contentSecondary = response.data;
          this.$nextTick(() => {
            const styleTags = document.getElementById('actContentSecondary').querySelectorAll('style');
            styleTags.forEach(styleTag => {
              styleTag.innerHTML = '#actContentSecondary' + styleTag.innerHTML;
              styleTag.innerHTML = styleTag.innerHTML.replace(/}/g, '} #actContentSecondary');
            });
            window.$("#actContentSecondary").on("click auxclick", function (e) {
              if (
                e.target.nodeName === "A" ||
                e.target.parentElement.nodeName === "A"
              ) {
                if (e.target.nodeName === "A") {
                  if (
                    e.target.href.includes("/prilozi") &&
                    !e.target.href.includes("actId")
                  )
                    e.target.href =
                      e.target.href + `&actId=${self.act.documentInfo.dataId}`;
                  else if (e.target.href.includes("/viewdoc"))
                    e.target.href = e.target.href.substr(
                      e.target.href.indexOf("/viewdoc")
                    );
                } else {
                  if (
                    e.target.parentElement.href.includes("/prilozi") &&
                    !e.target.parentElement.href.includes("actId")
                  )
                    e.target.parentElement.href =
                      e.target.parentElement.href +
                      `&actId=${self.act.documentInfo.dataId}`;
                }
              }
            });
          });
        });
      }
    },
    userInfo() {
      
    }
  },
  computed: {
    ...mapState(['userInfoState']),
  },
  methods: {
    closeSecondary() {
      this.contentSecondary = null;
      this.textSearchSecondary = "";
      this.contentSecondaryLink = "";
    },
    onPrintPrimaryClick() {
      console.log(this.userInfoState.roles)
      axios.get(this.baseApiUrl + "prins/viewdoc?uuid=" + this.act.documentInfo.htmlUuid + "&actId=" + this.$route.params.actId + "&doctype=sp")
        .then((response) => {
          var tab = window.open('', '_blank');
          tab.document.write(response.data); // where 'html' is a variable containing your HTML
          tab.document.close();
          setTimeout(() => {
            tab.print();
            tab.close();
          }, 100);
        })
    },
    onPrintSecondaryClick() {
      var printContents = window.$("#actContentSecondary").html();
      printContents = printContents.replace(/glasnik.css/, this.baseREGApiUrl + 'glasnik.css');
        var popupWin = window.open("", "_blank");
        popupWin.document.open();
        if (typeof printContents !== "undefined") {
          popupWin.document.write(
            '<html><head></head><body onload="window.print(); window.close();">' +
            printContents +
            "</body></html>"
          );
        }
        popupWin.document.close();
    },
    onOnlyActContentClick() {
      window.open(
        this.baseApiUrl +
        "prins/viewdoc?uuid=" +
        this.act.documentInfo.htmlUuid +
        "&actId=" +
        this.$route.params.actId +
        "&doctype=sp",
        "_blank"
      );
    },
    primaryKeyUp(event) {
      if (event.keyCode === 13) {
        this.onPrimaryNextClick();
      }
    },
    secondaryKeyUp(event) {
      if (event.keyCode === 13) {
        this.onSecondaryNextClick();
      }
    },
    onPrimaryPreviousClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexPrimary--;
        if (this.scrollIndexPrimary < 0) {
          this.scrollIndexPrimary = items.length;
        }
        if (items.length > 0) {
          items[this.scrollIndexPrimary].scrollIntoView();
        }
      }
    },
    onSecondaryPreviousClick() {
      var items = window.$("#actContentSecondaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexSecondary--;
        if (this.scrollIndexSecondary < 0) {
          this.scrollIndexSecondary = items.length;
        }
        if (items.length > 0) {
          items[this.scrollIndexSecondary].scrollIntoView();
        }
      }
    },
    onPrimaryNextClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexPrimary++;
        if (this.scrollIndexPrimary > items.length) {
          this.scrollIndexPrimary = 0;
        }
        items[this.scrollIndexPrimary].scrollIntoView();
      }
    },
    onSecondaryNextClick() {
      var items = window.$("#actContentSecondaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexSecondary++;
        if (this.scrollIndexSecondary > items.length) {
          this.scrollIndexSecondary = 0;
        }
        items[this.scrollIndexSecondary].scrollIntoView();
      }
    },
    handleArticleClick(event) {
      const target = event.target;
      if (
        target.tagName === "A" &&
        target.classList.contains("linkZaRegistar")
      ) {
        const dataCustomValue = target.getAttribute("data-click");
        this.openInline(dataCustomValue);
      }
    },
    openInline(link) {
      this.contentSecondaryLink = link;
    },
  },
  mounted() {
    axios
      .get(
        this.baseApiUrl +
        "Prins/GetCourtPracticeView/" +
        this.$route.params.actId
      )
      .then((response) => {
        this.act = response.data;
      })
      .catch((error) => {
        if(error.response.status === 403 || error.response.status === 401) window.location.href = '/'
        console.log(error);
      });
    // if (this.userInfoState) {
    //   console.log(this.userInfoState.roles)
    //  // const allowedRoles = ['SP', 'INTERNAL_USER'];
    //  // const hasAllRoles = allowedRoles.some((item) =>
    //     //this.userInfoState.roles.includes(item)
    //   //);
    //   if (this.userInfoState.roles.includes('SP'))

    //   //else this.$router.push({ path: '/' });
    // }
    // //else this.$router.push({ path: '/' });
  },

  beforeCreate: function () {
    document.body.className = "color_supa view-act-page";
  },
  components: { HtmlDiv },
};
</script>

<style scoped>
@import "~@fortawesome/fontawesome-free/css/all.css";

#actContentPrimaryScroll {
  height: 658px;
}

.color-header {
  background: #968753;
  background: -webkit-linear-gradient(top, #b09e60 0%, #968753 100%);
  background: -moz-linear-gradient(top, #b09e60 0%, #968753 100%);
  background: -ms-linear-gradient(top, #b09e60 0%, #968753 100%);
  background: -o-linear-gradient(top, #b09e60 0%, #968753 100%);
  background: linear-gradient(to bottom, #b09e60 0%, #968753 100%);
  background-color: rgba(0, 0, 0, 0);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#b09e60', endColorstr='#968753', GradientType=0);
  color: #ffffff !important;
  border: 0;
}

body {
  overflow-x: hidden;
}

@media (min-width: 1200px) {
  .col-lg-offset-2 {
    margin-left: 16.66666667%;
  }
}

.theme-supa .act-supa-table-title {
  height: 25px;
  background: #dbd7d2;
  color: #036104;
  line-height: 25px;
  border-left: 1px solid #a49e94;
  border-right: 1px solid #a49e94;
  font-weight: 600;
}

.theme-supa .act-supa-table-content {
  height: 30px;
  border-bottom: 1px solid #a49e94;
}

.theme-supa .act-supa-table-content {
  height: 25px;
  background: #ffffff;
  color: #036104;
  border-left: 1px solid #a49e94;
  border-right: 1px solid #a49e94;
  font-weight: 500;
  overflow: hidden;
}

.visible-xs {
  display: none !important;
}

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }

  .visible-xs {
    display: block !important;
  }

  .row-xs {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.theme-supa .right-panel {
  margin-bottom: 0px !important;
}

.col-lg-2-custom-class-width-12 {
  padding-bottom: 40px !important;
  padding-left: 5px !important;
  overflow-y: auto !important;
  height: 65vh !important;
  width: 13% !important;
  max-width: 13% !important;
  padding-right: 0px !important;
}

.panel-group .panel {
  margin-bottom: 0;
  border-radius: 4px;
}

.panel-default {
  border-color: #ddd;
  border: 1px solid #ddd !important;
  margin-bottom: 5px !important;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.theme-supa .panel-heading {
  background: #eaeaea;
  cursor: pointer;
  color: #333333 !important;

  :hover {
    text-decoration: underline;
  }
}

.theme-supa .panel-title {
  font-size: 88%;
  /*14px */
  margin-bottom: 0;
}

.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.input-group-btn:first-child>.btn,
.input-group-btn:first-child>.btn-group {
  margin-right: -1px;
}

.input-group-btn>.btn {
  position: relative;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 88%;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc !important;
}

.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child>.btn,
.input-group-btn:first-child>.btn-group>.btn,
.input-group-btn:first-child>.dropdown-toggle,
.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,
.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,
.input-group-btn:first-child>.btn:not(:first-child),
.input-group-btn:last-child>.btn,
.input-group-btn:last-child>.btn-group>.btn,
.input-group-btn:last-child>.dropdown-toggle {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-left: none;
}

.input-group-btn {
  display: flex;
  box-shadow: none !important
}

.base-body-wrap #actContentPrimaryScroll {
  border: none;
  overflow-y: hidden !important;
}

#actContentPrimaryScroll {
  height: calc(100vh - 320px) !important;
  background-color: white !important;
}

#actContentSecondaryScroll {
  height: calc(100vh - 320px) !important;
  background-color: white !important;
  overflow: auto;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.view-act {
  margin-top: 5px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  height: 100%;
  min-height: 200px;
}

.theme-supa .title-act-supa {
  color: #ffffff;
  text-align: center;
  border-bottom: 3px solid #ffffff;
  padding-left: 23px;
  padding-right: 23px;
}

.theme-supa .title-act-supa {
  min-height: auto;
}

.theme-supa .act-supa-table-content {
  height: 30px;
  border-bottom: 1px solid #a49e94;
  line-height: 1.4;
}

.btn-default:hover {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}

.theme-supa .panel-body {
  padding: 0 5px;
  margin: 5px 0;
}

.panel-body.list-group .list-group-item a {
  color: #337ab7 !important;
}

.panel-body.panel-collapse p {
  font-size: 70% !important;
  /*11px */
}

.act-supa-table-title {
  background-color: #ddd !important;
  border-left: 1px solid rgb(150, 169, 200) !important;
  border-right: 1px solid rgb(150, 169, 200) !important;
}

.act-supa-table-title span {
  font-size: 70% !important;
  color: rgb(74, 102, 147) !important;
  font-weight: 600 !important;
}

.act-supa-table-content span {
  font-size: 70% !important;
  color: rgb(74, 102, 147) !important;
  font-weight: 400 !important;
}

.act-supa-table-content {
  border-left: 1px solid rgb(150, 169, 200) !important;
  border-right: 1px solid rgb(150, 169, 200) !important;
}

.act-supa-table-content {
  border-left: 1px solid rgb(150, 169, 200) !important;
  border-right: 1px solid rgb(150, 169, 200) !important;
}

.row.mr-15 {
  margin-left: -15px;
  margin-right: -15px;
}

.row.mr-15 .col-lg-offset-2.col-lg-8.col-sm-12 {
  padding-left: 10px;
  padding-right: 10px;
}

#collapseSud,
#collapsePropisPresudjenja,
#collapseRelevantnoPravo,
#collapseOsporeniAkt,
#collapseAnonymizedAttachments,
#collapseAttachments,
#collapseReferences,
#collapseNaciniObjave,
#collapseObjava {
  font-size: 70% !important;
  /*11px*/
}

.panel-body.panel-collapse a:hover {
  text-decoration: underline;
}

.theme-supa .panel-body p {
  margin: 0 !important;
}

#primaryContentHtml {
  padding: 5px;
}

.row.visible-xs.blue-xs {
  font-size: 11px;
  text-align: left;
  color: #4a6693;
}

@media (max-width: 1200px) {
  .col-lg-2-custom-class-width-12 {
    width: 100% !important;
    padding: 20px !important;
    max-width: 100% !important;
  }

  .supa-panel {
    padding-right: 5px !important;
  }

  .title-act-supa {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

#searchBarPrimary input.form-control::placeholder,
.secondary-search input.form-control::placeholder {
  color: #a69999 !important;
  font-size: 100% !important;
  /*(14px) */
}

.secondary-search .btn-default:hover,
#searchBarPrimary .btn-default:hover {
  color: #333; 
  background-color: #e6e6e6 !important; 
  border-color: #adadad !important;
}
#searchBarPrimary input.form-control,
.secondary-search input.form-control {
  font-size: 88% !important;
  /*(14px) */
  height: 38px;
}

@media (max-width: 767px) {
  .row-xs {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>
